import React, {useEffect, useState, useMemo} from 'react';
import PropTypes from 'prop-types';
import {Box, Typography} from '@mui/material';
import * as allConstants from '../../../../../constants/allConstants';
import {useCreateJobStyles} from '../../createJobStyles';
import CustomFormBlock from '../../../../../pieces/inputs/formBlock';
import {inputTypes} from '../../../../../pieces/inputs/formInput';
import Utils from '../../../../../utils/utils';
import {AddRowButton, DeleteEquipmentRowButton} from '../../../../../pieces/addDeleteEquipmentRowButtons';
import {FormProvider, useFieldArray} from 'react-hook-form';
import ErrorIcon from '../../../../../static/images/alert-circle.svg';
//import Spacer from '../../../../../pieces/spacer';

const SystemEquipment = (props)=> {

//  const [showVarSpeedSys, setShowVarSpeedSys] = useState(false);
  const {eqName, formMethods, addFields, inputDefaultProps, fieldSet, errors, canModifyEquipment} = props;
  const classes = {...useCreateJobStyles()};

  const name_prefix = `${eqName}[0].fields`;
  const {fields, append, remove} = useFieldArray({
    control: formMethods.control,
    name:name_prefix
  });

  // const blockParent = `${props.parent}.${eqName}`;

  // console.log('props');
  // console.log(props);
  // console.log('parent');
  // console.log(blockParent);
  // console.log(`${eqName}`);
  
  // console.log('form methods');
  // console.log(formMethods);
  
  // const varSpeedSys = formMethods.watch(`${eqName}.${allConstants.EQUIPMENT.VARIABLE_SPEED_SYSTEM.api_name}`);

  // const equipVariableSys = useMemo( () => [allConstants.EQUIPMENT.CONDENSER.api_name, allConstants.EQUIPMENT.HEAT_PUMP_COND.api_name
  //                                       ,  allConstants.EQUIPMENT.MINI_SPLIT.api_name, allConstants.EQUIPMENT.MINI_SPLIT_DUCTED.api_name]);

  const values = formMethods.getValues();
  
  const getFieldValue = (fieldName, index)=> {
    const blockValues = values?.[`${eqName}`]?.[0]?.fields[index];
    return blockValues?.[fieldName];
  };

  // useEffect( () => {

  //   console.log('var sped sys');
  //   console.log(varSpeedSys);

  //   setShowVarSpeedSys(varSpeedSys === 'Yes');

  // },[varSpeedSys])

    // Thanh 01/01/2025
  const hideField = (fieldName, index) => {
    // if (fieldName != allConstants.JOB_FIELDS.SHARED.CONVERT_FROM.api_name &&
    //     fieldName != allConstants.JOB_FIELDS.SHARED.CONVERT_TO.api_name) {
    //   return false;
    // }

    switch (fieldName) {
      case allConstants.JOB_FIELDS.SHARED.CONVERT_FROM.api_name:
      case allConstants.JOB_FIELDS.SHARED.CONVERT_TO.api_name:
        const val1 = values?.[`${eqName}`]?.[0]?.fields[index]?.[allConstants.JOB_FIELDS.SHARED.ACTION.api_name];   
        if (val1 == undefined) return true;
        return (val1 != allConstants.CO_OR_NEW.CONVERSION.value);
      case allConstants.EQUIPMENT.VARIABLE_SPEED_SYSTEM.api_name:
        if (props.addressCity == undefined) return true;
        return (props.addressCity != 'CA');        

      case allConstants.EQUIPMENT.VAR_SPEED_SYS_LINK.api_name:
        const val2 = values?.[`${eqName}`]?.[0]?.fields[index]?.[allConstants.EQUIPMENT.VARIABLE_SPEED_SYSTEM.api_name];  
        
        if (val2 == undefined) return true;
        return (val2 != allConstants.ANSWER_OPTIONS.YES.value);        

      default:
        return false;
    }
  }

  useEffect(()=> {
    if(errors && errors.length !== 0) {
      try{
        const fields = errors[0]?.fields;
        if (fields && fields.length > 0) {
          const errorObj = Object.values(fields[0])[0];
          if(errorObj && errorObj.ref) {
            const el =document.getElementById(`${errorObj.ref?.name}-input`);
            el.scrollIntoView({behavior: 'smooth'});

          }
        }
      } catch (e){}
    }
  }, [errors]);

  return (
    <>
      {!props.hideEqName && <Typography variant={'subtitle1'} sx={{
        fontWeight: '600',
        '& span': {
          marginLeft: '4px'
        }
      }}>{allConstants.EQ_API_TO_NAME_MAPPING[eqName]}
        {errors && errors.length !== 0 && <span><img src={ErrorIcon} alt=""/></span>}
      </Typography>}

      <FormProvider {...formMethods}>
        <form>
          <Box className={classes.equipment_wrapper} sx={{
            ...props.sx,
            ...{maxWidth: {xs: '100%'}, paddingRight: '40px !important'}, minWidth:{xs: '100%', sm: '580px'}}}>
            {/* {equipVariableSys.includes(props.eqName)  && <>
              <div style={{ display: 'flex' }}>
                <div style={{ marginRight: '40px', whiteSpace: 'nowrap'}}>
                  <Box>
                      <CustomFormBlock {...inputDefaultProps} 
                        inputType={inputTypes.singleSelect}
                        options={Utils.getOptions(allConstants.ANSWER_OPTIONS, null)}
                        field={allConstants.EQUIPMENT.VARIABLE_SPEED_SYSTEM}
                        nested = {true}
                        parent = {`${eqName}`}
                      />
                  </Box>
                </div>
                {showVarSpeedSys &&
                <div style={{ flex: 1, marginTop: '4px'}}>
                  <a href="https://form.jotform.com/ipermit/refrigerant-charge-verification" target="_blank" rel="noopener noreferrer">
                      Refrigerant Change Verification
                  </a>
                </div>}
              </div>
             </>} */}
            {props.children}
            {fields.map((item, k) => {
              const additionalProps = {
                nested: true,
                parent: `${name_prefix}[${k}]`
              };
              return (
                <Box width={'100%'} className={classes.equipment} key={`${name_prefix}[${k}]`}>

                  {fieldSet.map((f, index)=> {
                    const required = f.field.required || f?.requiredFor && f.requiredFor.includes(eqName);
                   
                    return (
                      hideField(f.field.api_name, k) ?  null :
                      <Box key={index+f.field.api_name} className={f.wrapperClass} xs={{width: '165px'}} mr={2}>
                        <CustomFormBlock {...inputDefaultProps} {...additionalProps} {...f.uniqueProps}
                          inputType={f.inputType}
                          options={f.options ? Utils.getOptions(f.options, f.filterOptions) : undefined}
                          field={{...f.field, ...{required: required}}}
                          defaultValue={getFieldValue(f.field.api_name, k)}
                          fullWidth
                       
                          required={required}/>
                          
                      </Box>);
            
                  })}
                  {canModifyEquipment && <DeleteEquipmentRowButton eqName={eqName}
                    deleteAction={() => remove(k)}
                    index={k}
                  />}
                </Box>
              );
            })}
            {canModifyEquipment && <AddRowButton eqName={eqName}
              addAction={() => {append({...addFields});}}
            />}
          </Box>
        </form>
      </FormProvider>
    </>

  );

};

SystemEquipment.propTypes = {
  formMethods: PropTypes.shape({
    control: PropTypes.func.isRequired,
    getValues: PropTypes.func.isRequired
  }).isRequired,
  addFields: PropTypes.func.isRequired,
  inputDefaultProps: PropTypes.oneOfType([PropTypes.object]).isRequired,
  eqName: PropTypes.string.isRequired,
  fieldSet: PropTypes.instanceOf(Array).isRequired,
  errors: PropTypes.instanceOf(Array),
  canModifyEquipment: PropTypes.bool,
  hideEqName: PropTypes.bool,
  sx: PropTypes.instanceOf(Object)

};
SystemEquipment.defaultProps = {
  errors: [],
  canModifyEquipment: true,
  hideEqName: false,
  sx:{}
};
export {SystemEquipment};
